export const texts = {
   sectionTitle: {
    fontFamily: 'AvenirNext',
    fontSize: '34px',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#4a4a4a'
  },
  pageTitle: {
    fontFamily: 'AvenirNext-Medium',
    fontSize: '34px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#4a4a4a'      
  },
  pageSubtitle: {
    fontFamily: 'AvenirNext',
    fontSize: '20px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.6',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#4a4a4a'
  },
  buttonText: {
    fontFamily: 'AvenirNext',
    fontSize: '18px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1.33',
    letterSpacing: '1.5px',
    color: '#ffffff'
  },
  inputDefaultText: {
    fontFamily: 'AvenirNext',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
    color: '#bfbfbf'
  }
}